import * as React from 'react';
import type { IButtonProps } from '@fluentui/react';
import { Button } from '@fluentui/react-button';
import { DefaultButton, PrimaryButton, ActionButton } from '@fluentui/react';
import { isFeatureEnabled } from 'owa-feature-flags';

type ButtonPropsBase = Pick<
    IButtonProps,
    'text' | 'onClick' | 'className' | 'children' | 'disabled'
> &
    React.AllHTMLAttributes<
        HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | HTMLSpanElement
    >;

interface ButtonProps extends ButtonPropsBase {
    appearance?: 'primary' | 'transparent';
    as?: 'button';
    type?: 'button' | 'submit' | 'reset';
    shape?: 'rounded' | 'circular' | 'square';

    // TODO: Handle the `size` prop for the new button
    size?: never;
}

const ButtonMapping = {
    primary: PrimaryButton,
    transparent: ActionButton,
} as const;

export function FluentButton(props: ButtonProps) {
    if (isFeatureEnabled('fwk-fluent-v9')) {
        const { text, children, ...buttonProps } = props;
        return (
            <Button {...buttonProps}>
                <>
                    {text}
                    {children}
                </>
            </Button>
        );
    } else {
        const { appearance, ...buttonProps } = props;
        const ButtonType = appearance ? ButtonMapping[appearance] : DefaultButton;
        return <ButtonType {...buttonProps} />;
    }
}
